<!-- Footer -->
<footer class="footer font-small mdb-color lighten-3 pt-4">

  <!-- Footer Links -->
  <div class="container-fluid text-center text-md-left">

    <!-- Grid row -->
    <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="2%">

      <div fxFlex="10" fxFlex.lt-sm="100">
        <img src="../../../assets/1200px-Flag_of_Europe.svg.png" class="img-fluid" alt="EU logo" width="90" height="50" />
      </div>

      <div fxFlex="90" fxFlex.lt-sm="100">
        <p>
          The FAANG Data Coordination Centre has received funding from the
          <a href="https://ec.europa.eu/programmes/horizon2020/">European Union’s Horizon 2020</a>
          research and
          innovation program under Grant Agreement Nos. 815668, 817923 and 817998, and also from the
          <a href="https://bbsrc.ukri.org/">Biotechnology and Biological Sciences Research Council</a>
          under Grant Agreement No. BB/N019563/1.
        </p>
      </div>


    </div>
  </div>

</footer>
